import gql from 'graphql-tag';

export const RestoreContentMutation = gql`
	mutation RestoreContentMutation(
		$spaceKey: String!
		$restoreVersionContentId: String!
		$title: String
		$type: String!
	) {
		createContentContextual(
			input: {
				spaceKey: $spaceKey
				contentSpecificCreateInput: [
					{ key: "restoreVersionContentId", value: $restoreVersionContentId }
				]
				status: CURRENT
				title: $title
				type: $type
			}
		) {
			id
			links {
				context
				webui
			}
		}
	}
`;
